import { Button } from '@/components/ui/button';
import { CheckCircle2 } from 'lucide-react';
import type { BuildPlan, BuildStep } from '../../types';

interface CompletionBannerProps {
  buildPlan: BuildPlan | null;
  onContinueChat: () => void;
}

export function CompletionBanner({ buildPlan, onContinueChat }: CompletionBannerProps) {
  const verifiedCount =
    buildPlan?.steps.filter((s: BuildStep) => s.status === 'verified').length ?? 0;

  return (
    <div className="border-b bg-green-50 dark:bg-green-950/20 p-4 space-y-3">
      <div className="flex items-center gap-2">
        <CheckCircle2 className="h-5 w-5 text-green-600 dark:text-green-400" />
        <h3 className="text-sm font-semibold text-green-800 dark:text-green-200">Build Complete</h3>
      </div>

      {buildPlan && (
        <p className="text-xs text-muted-foreground">
          {buildPlan.name} &mdash; {verifiedCount} step{verifiedCount !== 1 ? 's' : ''} built and
          verified.
        </p>
      )}

      <div className="flex items-center gap-2">
        <Button variant="outline" size="sm" onClick={onContinueChat}>
          Continue in Chat
        </Button>
      </div>
    </div>
  );
}
